import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
// ProviderSettings removed - using Anchor Browser exclusively

export function Settings() {
  const { data: organization } = useQuery({
    queryKey: ['organization', 'current'],
    queryFn: () => api.getCurrentOrganization(),
  })

  const { data: integrations } = useQuery({
    queryKey: ['integrations'],
    queryFn: () => api.getIntegrations(),
  })

  const { data: members } = useQuery({
    queryKey: ['organization', 'members'],
    queryFn: () => api.getOrganizationMembers(),
  })

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage your organization settings and integrations
        </p>
      </div>

      {/* Provider Settings removed - using Anchor Browser exclusively */}

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* Organization Info */}
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Organization</h3>

          {organization && (
            <dl className="space-y-3">
              <div>
                <dt className="text-sm font-medium text-gray-500">Name</dt>
                <dd className="text-sm text-gray-900">{organization.name}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-gray-500">Plan</dt>
                <dd className="text-sm text-gray-900 capitalize">{organization.plan}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-gray-500">Created</dt>
                <dd className="text-sm text-gray-900">
                  {new Date(organization.created_at).toLocaleDateString()}
                </dd>
              </div>

            </dl>
          )}
        </div>

        {/* Team Members */}
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Team Members</h3>
          
          {members?.members.length ? (
            <div className="space-y-3">
              {members.members.map((member) => (
                <div key={member.id} className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-900">{member.email}</p>
                    <p className="text-xs text-gray-500 capitalize">{member.role}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">No members found</p>
          )}
        </div>

        {/* Integrations */}
        <div className="bg-white shadow rounded-lg p-6 lg:col-span-2">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium text-gray-900">Integrations</h3>
            <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
              Add Integration
            </button>
          </div>
          
          {integrations?.integrations.length ? (
            <div className="space-y-3">
              {integrations.integrations.map((integration) => (
                <div key={integration.id} className="flex items-center justify-between p-3 border rounded-lg">
                  <div>
                    <p className="text-sm font-medium text-gray-900 capitalize">
                      {integration.type}
                    </p>
                    <p className="text-xs text-gray-500">
                      {integration.enabled ? 'Enabled' : 'Disabled'}
                    </p>
                  </div>
                  <div className="flex space-x-2">
                    <button className="text-sm text-blue-600 hover:text-blue-500">
                      Edit
                    </button>
                    <button className="text-sm text-red-600 hover:text-red-500">
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-6">
              <p className="text-sm text-gray-500">No integrations configured</p>
              <p className="text-xs text-gray-400 mt-1">
                Add Slack or email integrations to receive notifications
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
